import {Navigate} from 'react-router-dom'
import {useAuth} from '../app/modules/auth'

type Props = {
  allowedRoles: string[]
  children: JSX.Element
}

export const RoleGuard = ({allowedRoles, children}: Props) => {
  const {currentUser} = useAuth()
  const role = currentUser?.profile?.rol

  if (!role) return <Navigate to='/auth/login' />

  if (!allowedRoles.includes(role)) {
    return <Navigate to='/operations/towels/delivery' />
  }

  return children
}
